import { render, staticRenderFns } from "./TitleParty.vue?vue&type=template&id=5a351154&"
import script from "./TitleParty.vue?vue&type=script&lang=js&"
export * from "./TitleParty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports